import { render } from "./PostTopic.vue?vue&type=template&id=3ee404e0&scoped=true"
import script from "./PostTopic.vue?vue&type=script&lang=ts"
export * from "./PostTopic.vue?vue&type=script&lang=ts"

import "./PostTopic.vue?vue&type=style&index=0&id=3ee404e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3ee404e0"

export default script